import React, {ChangeEvent, FormEvent, FunctionComponent, useEffect, useRef, useState} from 'react';
import "./AutoExpandableTextarea.scss"
import {Textarea} from "../ui-components/Textarea/Textarea";

interface AutoExpandableTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    initRows: number;
    maxRows: number;
}

export const AutoExpandableTextarea: FunctionComponent<AutoExpandableTextareaProps> = (props) => {
    const textareaRef = useRef<HTMLTextAreaElement>() as any;
    const [textareaRows] = useState<number>(props.initRows || 1);
    const [textareaMaxRows] = useState<number>(props.maxRows || 10);
    const [textareaHeight, setTextareaHeight] = useState<number>(0);
    const {initRows, maxRows, ...textareaProps} = props;

    useEffect(() => {
        if (textareaRef && textareaRef.current) {
            setTextareaHeight(textareaRef.current.offsetHeight);
            textareaRef.current.style.height = textareaRef.current.offsetHeight * props.initRows + 'px';
        }
    }, [false]);

    const onChange = (event: ChangeEvent) => {
        if (props.onChange) {
            props.onChange(event as ChangeEvent<HTMLTextAreaElement>);
        }
        updateTextareaHeight()
    }

    const onInput = (event: FormEvent) => {
        updateTextareaHeight()
    }

    const updateTextareaHeight = () => {
        const element = textareaRef.current;
        if (element.value && element.value.trim()) {
            (element.parentElement as HTMLElement).style.minHeight = `${element.scrollHeight - 10}px`;
            element.style.height = 'auto';
            element.style.height = `${element.scrollHeight}px`;
            if (element.scrollHeight > textareaHeight * props.initRows && (!props.maxRows || element.scrollHeight <= textareaHeight * props.maxRows)) {
                (element.parentElement as HTMLElement).style.minHeight = `${element.scrollHeight}px`;
            } else if (element.scrollHeight <= textareaHeight * textareaRows) {
                element.style.height = textareaHeight * textareaRows + 'px';
                (element.parentElement as HTMLElement).style.minHeight = element.style.height;
            } else if (textareaMaxRows) {
                element.style.height = textareaHeight * textareaMaxRows + 'px';
                element.className += ' scrollable-textarea';
                (element.parentElement as HTMLElement).style.minHeight = element.style.height;
            }
        }
    }

    return (
        <div className='autoexpandable-textarea-container'>
            <Textarea {...textareaProps} value={props.value} rows={textareaRows} ref={textareaRef} onChange={onChange}
                      onInput={onInput}/>
        </div>
    );
};